import { renderApp } from "./shared/createApp";
import { Tools } from "./shared/pages/Tools";

renderApp("tools", { tools: Tools });
